import setSelected from './setSelected';

// ----------------------------------------------------------------------------

function setValue(element: HTMLElement, value: string): void {
    setSelected(element, value);
}

// ----------------------------------------------------------------------------

export default setValue;
